var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__emoji_objects-24px",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2{fill:#757575}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_860",
    "data-name": "Group 860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2389",
    fill: "none",
    d: "M0 0H24V24H0z",
    "data-name": "Rectangle 2389"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_863",
    "data-name": "Group 863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_861",
    "data-name": "Group 861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_491",
    d: "M12 3a6.716 6.716 0 0 0-1.4.14 6.991 6.991 0 0 0-3.26 12.08A1.945 1.945 0 0 1 8 16.69V19a2.006 2.006 0 0 0 2 2h.28a1.979 1.979 0 0 0 3.44 0H14a2.006 2.006 0 0 0 2-2v-2.31a1.939 1.939 0 0 1 .64-1.46A6.992 6.992 0 0 0 12 3zm2 14h-4v-1h4zm-4 2v-1h4v1zm5.31-5.26c-.09.08-.16.18-.24.26H8.92a3.084 3.084 0 0 0-.24-.27A5 5 0 1 1 17 10a4.972 4.972 0 0 1-1.69 3.74z",
    className: "prefix__cls-2",
    "data-name": "Path 491"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_862",
    "data-name": "Group 862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2390",
    d: "M0 0H1V3H0z",
    className: "prefix__cls-2",
    "data-name": "Rectangle 2390",
    transform: "translate(11.5 11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2391",
    d: "M0 0H1V3H0z",
    className: "prefix__cls-2",
    "data-name": "Rectangle 2391",
    transform: "rotate(-45 16.401 -6.885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2392",
    d: "M0 0H1V3H0z",
    className: "prefix__cls-2",
    "data-name": "Rectangle 2392",
    transform: "rotate(-135 8.53 3.328)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreative);
export default __webpack_public_path__ + "static/media/creative.37d2be08.svg";
export { ForwardRef as ReactComponent };